import { useCallback, useMemo, useState, type ReactNode } from 'react'
import {
  PageTitleContext,
  type PageTitle,
  type PageTitleContextValue,
} from './page-title-context'

export function PageTitleProvider({ children }: { children: ReactNode }) {
  const [pageTitle, setPageTitleState] = useState<PageTitle | null>(null)

  const setPageTitle = useCallback<PageTitleContextValue['setPageTitle']>((next) => {
    setPageTitleState(next)
  }, [])

  const value = useMemo<PageTitleContextValue>(
    () => ({ pageTitle, setPageTitle }),
    [pageTitle, setPageTitle],
  )

  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>
}
